import { IOpData, ICopyable } from '../util/interfaces'

import { Enums } from '../common/enums'

import { OpDataType } from '../core/op-data-type'
import { Utils } from '../util/utils'
import { OpDistributor } from './op-distributor'
import { OpOperator } from './op-operator'


export class OpOperatorData implements IOpData, ICopyable<OpOperatorData> {

    //#region Properties

    public idDistributor: number
    public idOperatorData: number
    public idOperator: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //#endregion


    //#region NavigationProperties

    private _dataType: OpDataType = null
    public get dataType(): OpDataType {
        return this._dataType
    }
    public set dataType(value: OpDataType) {
        this._dataType = value
        this.idDataType = value != null ? value.idDataType : null
    }

    private _distributor: OpDistributor = null
    public get distributor(): OpDistributor {
        return this._distributor
    }
    public set distributor(value: OpDistributor) {
        this._distributor = value
        this.idDistributor = value != null ? value.idDistributor : null
    }

    private _operator: OpOperator = null
    public get operator(): OpOperator {
        return this._operator
    }
    public set operator(value: OpOperator) {
        this._operator = value
        this.idOperator = value != null ? value.idOperator : null
    }


    //#endregion


    //#region Ctor

    constructor(opObj: any = null) {
        if (opObj instanceof OpOperatorData) {
            this.copy(<OpOperatorData>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IOpData Implementation

    public get idData() { return this.idOperatorData }
    public set idData(value: number) { this.idOperatorData = value }
    public get indexNBR() { return this.indexNbr }
    public set indexNBR(value: number) { this.indexNbr = value }

    public opState: Enums.OpChangeState

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.dataType = opObj._DataType != null ? new OpDataType(opObj._DataType) : null
            this.distributor = opObj._Distributor != null ? new OpDistributor(opObj._Distributor) : null

            this.idOperatorData = opObj.ID_OPERATOR_DATA
            this.idOperator = opObj.ID_OPERATOR
            this.idDataType = opObj.ID_DATA_TYPE
            this.idDistributor = opObj.ID_DISTRIBUTOR
            this.indexNbr = opObj.INDEX_NBR
            this.value = opObj.VALUE
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_OPERATOR_DATA: this.idOperatorData,
            ID_OPERATOR: this.idOperator,
            ID_DATA_TYPE: this.idDataType,
            ID_DISTRIBUTOR: this.idDistributor,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value,
            OpState: this.opState
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpOperatorData {
        const newOperatorData: OpOperatorData = new OpOperatorData()

        newOperatorData.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newOperatorData
    }

    public copy(source: OpOperatorData, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        Utils.copyIOpData(this, source, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        this.idOperator = source.idOperator
        this.idOperatorData = source.idOperatorData
    }

    //#endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpOperatorData {
        const newData: OpOperatorData = new OpOperatorData(null)

        newData.idOperatorData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}